import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgArrowLargeDown32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M25.143 11.147a.5.5 0 1 1 .707.708l-9.855 9.852-9.849-9.853a.5.5 0 0 1 .708-.707l9.141 9.146 9.147-9.147z" /></SvgIcon>;
};
const Memo = memo(SvgArrowLargeDown32);
export default Memo;